import { render, staticRenderFns } from "./deliveryShippingTable.vue?vue&type=template&id=30f94ecc&scoped=true"
import script from "./deliveryShippingTable.vue?vue&type=script&lang=js"
export * from "./deliveryShippingTable.vue?vue&type=script&lang=js"
import style0 from "./deliveryShippingTable.vue?vue&type=style&index=0&id=30f94ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f94ecc",
  null
  
)

export default component.exports